import { Matches } from '@/screens/matches';

export default function MatchesScreen() {
  return <Matches />;
}
